import { MaintenancePanel } from "./MaintenancePanel";
import { WorkshopReport, OilDueCard } from "./WorkshopReport";

export const CarMaintenancePanel = () => (
  <div className="space-y-5">
    <MaintenancePanel type="car" showPurchase showMaintenance />
    <OilDueCard />
    <WorkshopReport />
  </div>
);
